import { BaseElement } from '../base-element';

export class AuthCallbackPage extends BaseElement {
  connectedCallback(): void {
    this.render(`
      <div class="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center" data-testid="auth-callback-page">
        <dt-spinner size="large"></dt-spinner>
        <div class="space-y-2">
          <h1 class="text-2xl font-semibold text-neutral-900 dark:text-white">Finishing secure sign-in...</h1>
          <p class="max-w-md text-sm text-neutral-500 dark:text-neutral-400">We’re confirming your sign-in and sending you back to the app.</p>
        </div>
      </div>
    `);
  }
}

customElements.define('dt-auth-callback-page', AuthCallbackPage);